export default "<div\n  #overlay\n  class=\"overlay\"\n  (keydown)=\"onKeydown($event)\"\n  (mousedown)=\"onClick($event)\"\n  tabindex=\"0\"\n></div>\n"